export default __webpack_public_path__ + "static/media/icon-back.0598369f.svg";